import { render, staticRenderFns } from "./ComprehensiveReport.vue?vue&type=template&id=743e3702"
import script from "./ComprehensiveReport.vue?vue&type=script&lang=js"
export * from "./ComprehensiveReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports